import { IOnboardingStepProps } from "../Onboarding";

import { View } from "./View";

export const OnboardingFour = (props: IOnboardingStepProps) => {
  return <View onSubmit={props.handleNext} {...props} />;
};
